import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Results.css';

function Results() {
  const location = useLocation();
  const navigate = useNavigate();
  const { score, answers, questions } = location.state || {};

  if (!score || !questions) {
    navigate('/');
    return null;
  }

  const passed = parseFloat(score) >= 61;
  const correctCount = questions.filter(q => {
    const userAnswer = answers[q.id] || [];
    const correctAnswers = q.options.filter(opt => opt.isCorrect).map(opt => opt.optionLetter).sort();
    return JSON.stringify([...userAnswer].sort()) === JSON.stringify(correctAnswers);
  }).length;

  return (
    <div className="results-container">
      <div className="container">
        {/* Results Header */}
        <div className={`results-header card ${passed ? 'passed' : 'failed'}`}>
          <div className="result-icon">
            {passed ? '🎉' : '📚'}
          </div>
          <h1>{passed ? 'Parabéns!' : 'Continue Estudando!'}</h1>
          <p className="result-message">
            {passed
              ? 'Você atingiu a pontuação necessária para aprovação!'
              : 'Você não atingiu a pontuação mínima desta vez, mas continue praticando!'}
          </p>
        </div>

        {/* Score Card */}
        <div className="score-card card">
          <div className="score-circle">
            <svg width="200" height="200">
              <circle cx="100" cy="100" r="90" fill="none" stroke="#e0e0e0" strokeWidth="12" />
              <circle
                cx="100"
                cy="100"
                r="90"
                fill="none"
                stroke={passed ? '#28a745' : '#dc3545'}
                strokeWidth="12"
                strokeDasharray={`${(parseFloat(score) / 100) * 565} 565`}
                transform="rotate(-90 100 100)"
              />
            </svg>
            <div className="score-text">
              <h2>{score}%</h2>
              <p>Pontuação</p>
            </div>
          </div>

          <div className="score-details">
            <div className="detail-item">
              <span className="detail-label">Questões Corretas</span>
              <span className="detail-value">{correctCount} / {questions.length}</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Necessário para Aprovação</span>
              <span className="detail-value">61%</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Status</span>
              <span className={`detail-badge ${passed ? 'passed' : 'failed'}`}>
                {passed ? '✅ Aprovado' : '❌ Reprovado'}
              </span>
            </div>
          </div>
        </div>

        {/* Review Questions */}
        <div className="review-section card">
          <h2>Revisão das Questões</h2>
          <div className="questions-review">
            {questions.map((q, index) => {
              const userAnswer = answers[q.id] || [];
              const correctAnswers = q.options.filter(opt => opt.isCorrect).map(opt => opt.optionLetter);
              const isCorrect = JSON.stringify([...userAnswer].sort()) === JSON.stringify([...correctAnswers].sort());

              return (
                <div key={q.id} className={`review-item ${isCorrect ? 'correct' : 'incorrect'}`}>
                  <div className="review-header">
                    <span className="review-number">Questão {index + 1}</span>
                    <span className={`review-status ${isCorrect ? 'correct' : 'incorrect'}`}>
                      {isCorrect ? '✅ Correta' : '❌ Incorreta'}
                    </span>
                  </div>

                  <p className="review-question">{q.questionText}</p>

                  {q.questionNote && (
                    <p className="review-note">
                      <strong>Nota:</strong> {q.questionNote}
                    </p>
                  )}

                  {/* Mostrar TODAS as opções expandidas */}
                  <div className="review-all-options">
                    {q.options.map(option => {
                      const wasSelected = userAnswer.includes(option.optionLetter);
                      const isCorrectOption = option.isCorrect;

                      let optionClass = 'review-option';
                      if (isCorrectOption) {
                        optionClass += ' option-correct'; // Verde
                      } else if (wasSelected) {
                        optionClass += ' option-wrong'; // Vermelho (usuário marcou errado)
                      }

                      return (
                        <div key={option.optionLetter} className={optionClass}>
                          <div className="option-header">
                            <span className="option-letter">{option.optionLetter}</span>
                            {isCorrectOption && <span className="option-badge correct">✓ Correta</span>}
                            {wasSelected && !isCorrectOption && <span className="option-badge wrong">✗ Sua escolha</span>}
                            {wasSelected && isCorrectOption && <span className="option-badge correct-choice">✓ Sua escolha</span>}
                          </div>
                          <p className="option-text">{option.optionText}</p>
                        </div>
                      );
                    })}
                  </div>

                  {q.explanation && q.explanation.trim() && (
                    <div className="review-explanation">
                      <strong>💡 Explicação:</strong>
                      <p>{q.explanation}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Actions */}
        <div className="results-actions">
          <button className="btn btn-primary btn-large" onClick={() => navigate('/config')}>
            Novo Simulado
          </button>
          <button className="btn btn-secondary btn-large" onClick={() => navigate('/')}>
            Voltar ao Início
          </button>
        </div>
      </div>
    </div>
  );
}

export default Results;
